import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';

import { hideFormChoiceModal, addOnlineForm } from 'actions/form';
import ModalWrapper from 'components/Modals/ModalWrapper';
import ModalInstructions from 'components/ModalInstructions';
import MustHaveReadText from 'components/MustHaveReadText';

const FormChoiceModal = ({ formType, dispatch }) => {
  const legalEntity = { id: 1 };
  const [allRead, setAllRead] = useState(false);
  const modalInstruction = ModalInstructions(formType);

  return (
    <ModalWrapper
      title={ modalInstruction != null && modalInstruction.FormChoiceTitle }
      disableConfirm={ !allRead }
      content={ modalInstruction != null
      && <MustHaveReadText
        content={ modalInstruction.FormChoiceContent }
        IsTextRead={ value => setAllRead(value) }
      /> }
      footer={ !allRead ? 'You must read all the instruction before proceeding.' : 'By continuing, you confirm you have read and understood the text above.' }
      onCancel={ () => dispatch(hideFormChoiceModal()) }
      onConfirm={ () => { dispatch(hideFormChoiceModal()); dispatch(addOnlineForm(formType, legalEntity)); } }
    />);
};

FormChoiceModal.defaultProps = {
  formType: ''
};

FormChoiceModal.propTypes = {
  formType: PropTypes.string,
  dispatch: PropTypes.func.isRequired
};

function mapStateToProps(state) {
  const {
    form: {
      formType,
      isFormChoiceShown
    }
  } = state;

  return {
    formType,
    isFormChoiceShown
  };
}

const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FormChoiceModal);
